import { render } from "./OAuthConfiguration.vue?vue&type=template&id=35ffa3e3&scoped=true&lang=pug"
import script from "./OAuthConfiguration.vue?vue&type=script&lang=js"
export * from "./OAuthConfiguration.vue?vue&type=script&lang=js"

import "./OAuthConfiguration.vue?vue&type=style&index=0&id=35ffa3e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ffa3e3"]])

export default __exports__